export const toastOptions = {
  success: {
    style: {
      background: "#EAFBF5",
      border: "1px solid #005A3A",
    },
  },
  error: {
    style: {
      background: "#FFEDED",
      border: "1px solid #D21919",
    },
  },
}